import React, { Component } from 'react';
import * as PAGE from '../Constants/Page.js';

export default function Failed(props) {
    
   

        return (
            <div>
                <div>
                    <p>A problem was encountered when trying to confirm your reservation: {props.error}</p>
                </div>

                <div>
                    <button className='btn btn-warning' onClick={() => window.location.reload(false)}> Try Again </button>
                
                </div>
            </div>
        );

    
} 